export default {
  'pages.businessAppMarket.title': '应用市场',
  'pages.businessAppMarket.subtitle':
    '发现适合团队的业务应用，按需开通并集中使用。',
  'pages.businessAppMarket.backToCenter': '返回应用',
  'pages.businessAppMarket.myApps': '我的应用',
  'pages.businessAppMarket.refresh': '刷新',
  'pages.businessAppMarket.searchLabel': '应用名称',
  'pages.businessAppMarket.searchPlaceholder': '搜索应用名称或描述',
  'pages.businessAppMarket.search': '搜索',
  'pages.businessAppMarket.pricingLabel': '价格类型',
  'pages.businessAppMarket.all': '全部',
  'pages.businessAppMarket.free': '免费',
  'pages.businessAppMarket.paid': '付费',
  'pages.businessAppMarket.categoryLabel': '应用分类',
  'pages.businessAppMarket.allCategories': '全部分类',
  'pages.businessAppMarket.resetFilters': '重置筛选',
  'pages.businessAppMarket.resultCount': '共 {count} 个应用',
  'pages.businessAppMarket.loadError': '应用市场加载失败',
  'pages.businessAppMarket.loadErrorDescription':
    '暂时无法获取应用信息，请稍后重试。',
  'pages.businessAppMarket.retry': '重试',
  'pages.businessAppMarket.empty': '暂无上架应用',
  'pages.businessAppMarket.filteredEmpty': '未找到符合条件的应用',
  'pages.businessAppMarket.emptyDescription':
    '请调整筛选条件，或稍后查看新上架应用。',
  'pages.businessAppMarket.details': '查看详情',
  'pages.businessAppMarket.detailTitle': '应用详情',
  'pages.businessAppMarket.description': '应用介绍',
  'pages.businessAppMarket.developer': '开发者',
  'pages.businessAppMarket.unknownDeveloper': '开发者未提供',
  'pages.businessAppMarket.noDescription': '暂无应用介绍',
  'pages.businessAppMarket.certification': '认证信息',
  'pages.businessAppMarket.official': '官方认证',
  'pages.businessAppMarket.unverified': '未认证',
  'pages.businessAppMarket.category': '应用分类',
  'pages.businessAppMarket.uncategorized': '未分类',
  'pages.businessAppMarket.price': '价格',
  'pages.businessAppMarket.contactRequired': '联系运营',
  'pages.businessAppMarket.contactReason':
    '未配置销售价格、采用按席位定价或开通方式尚未明确，请联系运营支持。',
  'pages.businessAppMarket.freeActivate': '免费开通',
  'pages.businessAppMarket.paidActivate': '购买开通',
  'pages.businessAppMarket.open': '打开应用',
  'pages.businessAppMarket.unavailableUrl': '暂未配置可用的访问地址',
  'pages.businessAppMarket.installed': '已开通',
  'pages.businessAppMarket.previewImages': '应用预览',
  'pages.businessAppMarket.previewAlt': '{name}预览图 {index}',
  'pages.businessAppMarket.noPreview': '暂无预览图片',
  'pages.businessAppMarket.close': '关闭',
  'pages.businessAppMarket.missingApp': '未找到该应用',
  'pages.businessAppMarket.missingAppDescription':
    '当前目录结果中未找到该应用，请搜索应用名称后重试。应用也可能已下架。',
  'pages.businessAppMarket.clearDetails': '返回市场列表',
  'pages.businessAppMarket.detailLoadError': '应用详情加载失败',
  'pages.businessAppMarket.detailLoading': '正在加载应用详情',
  'pages.businessAppMarket.confirmFreeTitle': '确认免费开通',
  'pages.businessAppMarket.confirmPaidTitle': '确认购买开通',
  'pages.businessAppMarket.confirmFreeDescription':
    '将为当前企业开通「{name}」。',
  'pages.businessAppMarket.confirmPaidDescription':
    '将为当前企业创建「{name}」的购买订单，价格为 {price}。',
  'pages.businessAppMarket.confirm': '确认',
  'pages.businessAppMarket.cancel': '取消',
  'pages.businessAppMarket.activateSuccess': '应用开通成功',
  'pages.businessAppMarket.alreadyActive': '应用已开通',
  'pages.businessAppMarket.activateError': '应用开通失败，请稍后重试。',
  'pages.businessAppMarket.orderError': '创建订单失败，请稍后重试。',
  'pages.businessAppMarket.confirmationError':
    '无法确认开通条件，请刷新后重试。',
  'pages.businessAppMarket.contextChanged':
    '企业或登录状态已变更，请刷新后重新操作。',
  'pages.businessAppMarket.sessionRequired': '请登录并选择企业后继续。',
};
